const ERROR_CODES = {
  FORGOT_EMAIL_3_POINT_CHECK: 'forgot-email:3-point-check-error',
  FORGOT_EMAIL_ACCOUNT_SEARCH: 'forgot-email:account-search-error',
  FORGOT_PASSWORD_3_POINT_CHECK: 'forgot-password:3-point-check-error',
  MANUAL_REG_3_POINT_CHECK: 'register:3-point-check-error',
  MANUAL_REG_ACCOUNT_SEARCH: 'register:account-search-error',
  MANUAL_REG_OTC_ERROR: 'manual-reg:otc-error',
  MANUAL_REG_SAP_EMAIL_ERROR: 'manual-reg:sap-email-error',
  MANUAL_REG_SAP_CREATE_ERROR: 'manual-reg:sap-create-error',
  SET_PW_ERROR: 'reset-pw-error',
};

export { ERROR_CODES };
